const csrfToken = () =>
  document.querySelector('[name="csrf-token"]').getAttribute("content")

export function runAction(url, actionType, actionData, callbacks) {
  callbacks.onStart(actionType)

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify({ action_type: actionType, action_data: actionData }),
  })
    .then((response) => response.json())
    .then((result) => {
      if (result.requires_selection) {
        callbacks.onSelection(result)
      } else if (result.success) {
        callbacks.onSuccess(result)
      } else {
        callbacks.onError(result)
      }
    })
    .catch(() => {
      callbacks.onError({ message: "Network error occurred" })
    })
}

export function showProgressModal(el, titleEl, stepsEl, barEl, actionType) {
  titleEl.textContent = `Executing ${actionType.replaceAll("_", " ")}`
  stepsEl.innerHTML = ""
  barEl.style.width = "0%"
  el.classList.remove("hidden")
}

export function hideProgressModal(el) {
  el.classList.add("hidden")
}

export function addProgressStep(stepsEl, message, status) {
  const step = document.createElement("div")
  step.className = "flex items-center text-sm"

  const textColor =
    status === "completed" ? "text-green-700" : status === "error" ? "text-red-700" : "text-gray-700"

  step.innerHTML = `<span class="${textColor}">${message}</span>`
  stepsEl.appendChild(step)
}

export function updateProgressBar(barEl, percentage) {
  barEl.style.width = `${percentage}%`
}

export function buildSubscriptionOptionsHtml(options, controllerName) {
  return options
    .map((sub) => {
      const statusClass =
        sub.status === "active" ? "border-green-300 bg-green-50" : "border-gray-300 bg-gray-50"
      const recommended =
        sub.status === "active"
          ? '<span class="text-green-600 font-semibold ml-2">(Recommended)</span>'
          : ""
      const statusLabel = sub.status === "active" ? "Active" : sub.status

      return `
        <div class="border ${statusClass} rounded-lg p-4 cursor-pointer hover:bg-opacity-75"
             data-action="click->${controllerName}#selectSubscription"
             data-subscription-id="${sub.subscription_id}">
          <div class="flex items-center justify-between">
            <div>
              <div class="font-medium">Subscription ${sub.subscription_id}</div>
              <div class="text-sm text-gray-600">Status: ${sub.status}${recommended}</div>
              <div class="text-xs text-gray-500">Created: ${new Date(sub.created * 1000).toLocaleDateString()}</div>
              <div class="text-xs ${sub.has_db_record ? "text-orange-600" : "text-green-600"}">
                ${sub.has_db_record ? "Already exists in database" : "Will be created"}
              </div>
            </div>
            <span class="text-sm font-medium ${sub.status === "active" ? "text-green-600" : "text-gray-500"}">${statusLabel}</span>
          </div>
        </div>
      `
    })
    .join("")
}
